/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type cancelPolicySpace_policy$ref: FragmentReference;
declare export opaque type cancelPolicySpace_policy$fragmentType: cancelPolicySpace_policy$ref;
export type cancelPolicySpace_policy = {|
  +slug: ?string,
  +rules: ?$ReadOnlyArray<?{|
    +payback: ?number,
    +when: ?number,
  |}>,
  +$refType: cancelPolicySpace_policy$ref,
|};
export type cancelPolicySpace_policy$data = cancelPolicySpace_policy;
export type cancelPolicySpace_policy$key = {
  +$data?: cancelPolicySpace_policy$data,
  +$fragmentRefs: cancelPolicySpace_policy$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "cancelPolicySpace_policy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PolicyRules",
      "kind": "LinkedField",
      "name": "rules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "payback",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "when",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Policy",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'a1ba7ddc2df5b3b174a354beb4bdc8f1';

module.exports = node;
